module.exports = __webpack_public_path__ + "1f751fa85d6594037526afd2c5d37478.MP3";